import {Component, MeshComponent} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';

/**
 * flag
 */
export class Flag extends Component {
    static TypeName = 'flag';

    /* Properties that are configurable in the editor */

    @property.enum(['red', 'blue'])
    team!: number;

    baseMesh!: MeshComponent;
    flagMesh!: MeshComponent;
    poleMesh!: MeshComponent;

    start() {
        this.flagMesh = this.object.getComponent(MeshComponent, 0)!;
        this.baseMesh = this.object.getComponent(MeshComponent, 1)!;
        this.poleMesh = this.object.getComponent(MeshComponent, 2)!;
    }

    drop(pos: number[]) {
        this.object.setPositionWorld(pos);
        this._setVisible(true);
    }

    take() {
        this._setVisible(false);
    }

    return(pos: number[]) {
        this.drop(pos);
    }

    private _setVisible(b: boolean) {
        this.baseMesh.active = b;
        this.poleMesh.active = b;
        this.flagMesh.active = b;
    }
}
